export enum RollForwardWizardStep {
  Filters = "filters",
  SourceTarget = "source_target",
  ContinuityAndDates = "continuity_and_dates",
  Summary = "summary"
}

export const ROLL_FORWARD_WIZARD_STEP_ORDER = Object.values(RollForwardWizardStep);

export const ROLL_FORWARD_WIZARD_PATH = "/workflow/engagements/roll_forward";

// TODO: [SP-12116] remove the roll_forward_wizard flag key when the Roll Forward Wizard epic is ready
export const ROLL_FORWARD_WIZARD_FLAG_KEY = "roll_forward_wizard";
